import React, { useState } from 'react';
import "./platforms.css"
import main_block_bg from "./images/main_page_bg.svg";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion } from "framer-motion";
import PlatformsItem from "./components/PlatformsItem";

const Platforms = () => {
    const tabs = ["New", "Most popular", "Best rated"];
    const [activeIndex, setActiveIndex] = useState(0);



    const staggerContainer = {
        hidden: {},
        visible: { transition: { staggerChildren: 0.2 } },
    };



    const pointVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.15, duration: 0.6, ease: "easeOut" }
        })
    };
    const fadeNumeric = {
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: true },
        variants: pointVariants
    };
    // Разные варианты анимации
    const fadeUp = { initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeDown = { initial: { opacity: 0, y: -40 }, whileInView: { opacity: 1, y: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeLeft = { initial: { opacity: 0, x: -50 }, whileInView: { opacity: 1, x: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeRight = { initial: { opacity: 0, x: 50 }, whileInView: { opacity: 1, x: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };



    return (
        <div className="platforms_page">
            <motion.img src={main_block_bg} alt="" className="main_block_bg" {...fadeUp}/>
            <Header/>

            <div
                className="for_donors_main_block"
            >
                <motion.div className="for_donors" {...fadeUp}>
                    <div className="circle"></div>
                    Powered by Undura Lite
                </motion.div>
                <div className="main_block_text">
                    <motion.div className="main_text" {...fadeLeft}>
                        Connected ecosystem for transparent giving
                    </motion.div>
                    <motion.div className="main_block_desc" {...fadeRight}>
                        <div className="main_desc">
                            Explore verified fundraising platforms built on Undura Lite — where trust, visibility, and
                            impact come together.
                        </div>
                    </motion.div>
                </div>
            </div>

            {/* <motion.div
                className="ecosystem_type_full_width"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
            >
                <div className="ecosystem_type">
                    <motion.div
                        className="ecosystem_type_highlight"
                        animate={{left: `calc(${activeIndex} * ((100% - 8px) / 3) + 4px)`}}
                        transition={{type: "spring", stiffness: 300, damping: 30}}
                    />
                    {tabs.map((tab, index) => (
                        <motion.div
                            key={tab}
                            className={`ecosystem_type_point ${index === activeIndex ? "active" : ""}`}
                            onClick={() => setActiveIndex(index)}
                            whileHover={{ scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300 }}
                        >
                            {tab}
                        </motion.div>
                    ))}
                </div>
            </motion.div>

            <motion.div
                className="platforms_list"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={staggerContainer}
            >
                {[1, 2, 3].map((i) => (
                    <motion.div key={i} variants={fadeUp}>
                        <PlatformsItem/>
                    </motion.div>
                ))}
            </motion.div>*/}

            <Footer mode = "lite"/>
        </div>
    );
};

export default Platforms;
